var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { apiGetListRelease } from '@/actions/ReleaseActions';
import { usePromiseDoingCallback } from '@/hooks/async/loading/usePromiseDoingCallback';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { SESSION_STORAGE_KEY_RELEASE_LIST } from '@/utils/constants/storage/sessionStorageKey';
import { stringifyUrl } from '@/utils/libs/query-string/stringify';
import { useSessionStorage } from '@/utils/libs/react-hookz/useSessionStorage';
import { releaseListPath } from '@/utils/router/links';
/**
 * お知らせ一覧のデータを取得するカスタムフック
 */
export const useReleaseListFetch = () => {
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const history = useNavigate();
    // お知らせ一覧のデータを保存
    const { set: setReleaseList, value: releaseList } = useSessionStorage(SESSION_STORAGE_KEY_RELEASE_LIST, {
        defaultValue: {},
    });
    /**
     * お知らせ一覧のデータ取得
     */
    const fetchReleaseListBase = useCallback((page) => __awaiter(void 0, void 0, void 0, function* () {
        const { payload } = yield wrapDispatch(dispatch, apiGetListRelease({ query: { page } }, {}));
        // 取得したデータを sessionStorage に保存
        setReleaseList((prev) => (Object.assign(Object.assign({}, prev), { [payload.pagination.current_page]: payload })));
    }), [dispatch, setReleaseList]);
    // ローディング制御
    const { callbackPromiseEvent: fetchReleaseList, doing: loading } = usePromiseDoingCallback({
        initialDoingState: true,
        promiseEvent: fetchReleaseListBase,
        unmountRef,
    });
    /**
     * ボタンクリック時の処理
     * @description URL の更新
     */
    const onChangePage = useCallback((selected) => __awaiter(void 0, void 0, void 0, function* () {
        const selectedPage = selected + 1;
        // URL の更新
        history.push(stringifyUrl({
            query: { page: selectedPage },
            url: releaseListPath(),
        }));
    }), [history]);
    return {
        fetchReleaseList,
        loading,
        onChangePage,
        releaseList,
    };
};
